<template>
<!-- Author: lan.h
Date: 2021-10-25
content: 导航 -->
  <div class="menu-content">
    <div class="menu">
      <router-link class="menu-left" :to="{name:'index'}" @click.native="flushCom">
        <img src="~/img/logo.png" />
      </router-link>
      <div class="menu-right" @click="is_nav = true">
        <img src="~/img/nav.png" />
      </div>
    </div>
    <transition name="plus">
      <div class="nav-mask" v-if="is_nav">
        <div class="nav-header">
          <router-link class="nav-left" :to="{name:'index'}" @click.native="flushCom">
            <img src="~/img/logo_w.png" />
          </router-link>
          <div class="nav-right" @click="is_nav = false">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="nav-content" @click="is_nav = false">
          <router-link :to="{name:'index'}" @click.native="flushCom">
            <h1>首页</h1>
            <p>HOME</p>
          </router-link>
          <router-link v-for="item in awards_meta" :key="item.id" :to="{name: item.route}">
            <h1>{{item.name}}</h1>
            <p v-if="item.route == 'vb100List'">VB100-FHC LISTS</p>
            <p v-if="item.route == 'pcAward'">PENGCHENG AWARDS</p>
            <p v-if="item.route == 'wlAward'">WEILAN AWARDS</p>
            <p v-if="item.route == 'oAward'">CHENGGUO AWARDS</p>
            <p v-if="item.route == 'wAward'">VB100-FHC SUB-LISTS</p>
          </router-link>
          <router-link :to="{name:'release'}">
            <h1>历届发布</h1>
            <p>PREVIOUS</p>
          </router-link>
          <router-link :to="{name:'org'}">
            <h1>支持机构</h1>
            <p>ORGANIZATION</p>
          </router-link>
          <router-link :to="{name:'report'}">
            <h1>报告下载</h1>
            <p>REPORT</p>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      is_nav: false
    }
  },
  computed: {
    awards_meta() {
      return this.$store.state.list_meta.awards_meta.filter(item => item.route)
    }
  },
  methods: {
    flushCom () {
      this.$router.go(0)
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu
  padding .34rem .4rem 0
  display flex
  justify-content space-between
  align-items stretch
  height .75rem
  position fixed
  left 0
  top 0
  width 100%
  z-index 2000
  .menu-left 
    display block
    img 
      height .4rem
  .menu-right
    width .6rem
    display flex
    justify-content center
    align-items center
    img 
      height .3rem
.nav-mask
  background #1F2330
  position fixed
  left 0
  top 0
  bottom 0
  right 0
  z-index 2010
  .nav-header
    display flex
    justify-content space-between
    align-items center
    padding .34rem .4rem 0
    height .75rem
    .nav-left 
      display block
      img
        height .4rem
    .nav-right 
      width .6rem
      height .6rem
      background #FFFFFF
      border-radius 50%
      display flex 
      justify-content center 
      align-items center
      i 
        font-size .32rem
        color #D9BB9E
  .nav-content 
    padding-left .4rem
    overflow auto
    height calc(100vh - 1.5rem)
    margin-top .5rem
    a 
      color #fff
      margin-top .5rem
      display block
      h1 
        font-size .5rem
        font-weight 500
        line-height 1
      p 
        margin-top .2rem
        font-weight bold
        font-size .24rem
        line-height 1
    a:first-child
      margin-top 0
.plus-enter 
  opacity 0
.plus-enter-active 
  transition  opacity .8s
.plus-enter-to 
  opacity 1
.plus-leave
  opacity 1
.plus-leave-active 
  transition  opacity .8s
.plus-leave-to 
  opacity 0
</style>